import { render, staticRenderFns } from "./UserTile.vue?vue&type=template&id=278bc8f4&scoped=true&lang=pug&"
import script from "./UserTile.vue?vue&type=script&lang=js&"
export * from "./UserTile.vue?vue&type=script&lang=js&"
import style0 from "./UserTile.vue?vue&type=style&index=0&id=278bc8f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bc8f4",
  null
  
)

export default component.exports